import { useContext, useEffect } from 'react'
import { AuthenticationContext } from '../../AuthenticationContext'
import { useSettledPaymentsCountQuery } from '../../domain/invoicing/settledPaymentsQueries'
import { sendSettledPaymentsSignal } from './settledPaymentsSurveyModel'

const SettledPaymentsSurveySignal = () => {
  const { currentUser } = useContext(AuthenticationContext)
  const query = useSettledPaymentsCountQuery(!!currentUser)

  useEffect(() => {
    if (query.data !== undefined) {
      sendSettledPaymentsSignal(query.data.settledPaymentsCount)
    }
  }, [query.data])

  return null
}

export default SettledPaymentsSurveySignal
